import { useCallback, useEffect, useRef, useState } from 'react';
import { ChatStreamCallbacks, chatStream } from '../../api/aiAssistant';

/**
 * 对话流式发送 hook。
 *
 * KeepAlive 说明：页面切走时组件不卸载，流继续在后台完成（切回来消息已完整），
 * 因此只在组件真正 unmount、切换会话或重新发送时 abort。
 */
export function useChatStream(companyId: string | number) {
  const abortRef = useRef<AbortController | null>(null);
  const [streaming, setStreaming] = useState(false);

  const send = useCallback(
    async (
      body: { conversationId?: string; content: string },
      callbacks: ChatStreamCallbacks,
    ) => {
      abortRef.current?.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      setStreaming(true);
      try {
        await chatStream(companyId, body, callbacks, controller.signal);
      } finally {
        if (abortRef.current === controller) {
          setStreaming(false);
        }
      }
    },
    [companyId],
  );

  const abort = useCallback(() => {
    abortRef.current?.abort();
    setStreaming(false);
  }, []);

  useEffect(() => () => abortRef.current?.abort(), []);

  return { send, abort, streaming };
}
